const FEATURES = [
  {
    icon: 'ri-flashlight-line',
    title: '全网最快',
    desc: '7×24小时不间断追踪娱乐圈最新动态，明星大瓜第一时间送达，让你永远快人一步吃到最新鲜的瓜。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清不卡',
    desc: '全部吃瓜视频采用高清片源，多线服务器智能加速，无论何时何地观看都流畅不卡顿，极致观看体验。',
  },
  {
    icon: 'ri-calendar-check-line',
    title: '每日更新',
    desc: '编辑团队每日精选最新最热的明星爆瓜视频和吃瓜现场实录，保持高频更新节奏，精彩大瓜永不断档。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">吃瓜优势</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            为什么百万瓜友选择在每日吃瓜追更？三大核心优势给你答案
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {FEATURES.map((item, i) => (
            <div
              key={i}
              className="group p-6 md:p-8 bg-background-50 border border-background-200/70 rounded-xl text-center transition-all duration-300 hover:border-primary-200/60"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 flex items-center justify-center bg-primary-100 rounded-2xl group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-primary-500 text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl text-foreground-950 mb-3">{item.title}</h3>
              <p className="text-foreground-600 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}